import {
  UPDATE_START_TIME_SUCCESS,
  POST_ROUTE_SUCCESS,
  UPDATE_STAY_TIME_SUCCESS,
  UPDATE_TRIP_INFO_SUCCESS,
  COPY_POI_SUCCESS,
  REMOVE_POIS_SUCCESS,
  POST_TEXT_NOTE_SUCCESS,
  EDIT_ALIAS_NAME_SUCCESS,
  CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS,
  ONE_MORE_DAY_SUCCESS,
  REMOVE_DAYS_SUCCESS,
  ADD_POI_SUCCESS,
  UPDATE_PERMISSION_OF_TRIP_SUCCESS,
  SYNC_REMOVE_TRAVEL_COMPANIONS_SUCCESS,
  REINDEX_POI_SEQUENCE_SUCCESS,
  REARRANGE_POI_SEQUENCE_SUCCESS,
  LISTEN_CONNECT_REVISION
} from './action_types';
import { sendMessageToastAction } from './commonAction';
import { ITINERARY_SQUAWK } from '../constants/response';

export const syncData = response => dispatch => {
  const { command, results } = response;
  if (command === 'editStartTime') {
    // collaboration is a flag for reducers to aggisn to different handlers for success action
    dispatch({
      type: UPDATE_START_TIME_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'postRoute') {
    dispatch({
      type: POST_ROUTE_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'editStayTime') {
    dispatch({
      type: UPDATE_STAY_TIME_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'updateTripInfo') {
    dispatch({
      type: UPDATE_TRIP_INFO_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'copyPoi') {
    dispatch({
      type: COPY_POI_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'deletePois') {
    dispatch({
      type: REMOVE_POIS_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'postTextNote') {
    dispatch({
      type: POST_TEXT_NOTE_SUCCESS,
      // shouldSyncWithServer means if you did not send the post request to server,
      // you should sync with server to get new text note
      payload: {
        results: {
          ...results,
          shouldSyncWithServer: true,
          collaboration: true
        }
      }
    });
  } else if (command === 'editAliasNameOfPoi') {
    dispatch({
      type: EDIT_ALIAS_NAME_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'customizeTransportationTime') {
    dispatch({
      type: CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS,
      payload: { ...results, collaboration: true }
    });
  } else if (command === 'oneMoreDay') {
    dispatch({
      type: ONE_MORE_DAY_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'removeDays') {
    dispatch({
      type: REMOVE_DAYS_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'addPoi') {
    dispatch({
      type: ADD_POI_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
    dispatch(sendMessageToastAction('Added to itinerary'));
  } else if (command === 'updatePermissionOfTrip') {
    dispatch({
      type: UPDATE_PERMISSION_OF_TRIP_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'removeTravelCompanions') {
    dispatch({
      type: SYNC_REMOVE_TRAVEL_COMPANIONS_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'reindexPoiSequence') {
    dispatch({
      type: REINDEX_POI_SEQUENCE_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  } else if (command === 'reindexDaySequence') {
    // return { type: REINDEX_DAY_SEQUENCE_SUCCESS, payload: { ...results, collaboration: true } };
    // dispatch({ type: FETCH_POIS, payload: { tripObjectId: results.parseTripObjectId } });
  } else if (command === 'rearrangePoiSequence') {
    dispatch({
      type: REARRANGE_POI_SEQUENCE_SUCCESS,
      payload: { results: { ...results, collaboration: true } }
    });
  }
};

export const syncRevision = (response, revision) => dispatch => {
  let transponder = ITINERARY_SQUAWK.PXY_OKAY;
  const isRefreshNeeded = response.refresh;
  const isTypeMatch = revision.slice(1, -3) === response.revision.slice(1, -3);
  const isRevMatch = revision.slice(-3) === response.revision.slice(-3);
  if (isRefreshNeeded && !isTypeMatch && !isRevMatch) {
    transponder = ITINERARY_SQUAWK.EDIT_CONFLICT;
  }
  if (isRefreshNeeded && isTypeMatch && !isRevMatch) {
    transponder = ITINERARY_SQUAWK.SOCKET_TIMEOUT;
  }
  dispatch({
    type: LISTEN_CONNECT_REVISION,
    payload: { status: transponder }
  });
};
